import React, { useEffect, useRef, useState } from "react";
import { usePromotionsContext } from "../../hooks/usePromotionsContext";
import { FormattedMessage } from "react-intl";
import { Modal } from "react-bootstrap";
import promotionAppliedIcon from "../../images/promotion-applied-icon.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../state/store";

const AppliedPromotionsModalMobile = () => {
  const {
    newlyAppliedPromotions,
    userAcknowledgedPromotionsHandler,
    toggleUserClosePromotionPopup,
  } = usePromotionsContext();
  const [show, setShow] = useState(false);
  const currentAppliedPromotionRef = useRef<null | any>(null);
  const { availablePromotions } = useSelector(
    (state: RootState) => state.promotions
  );

  useEffect(() => {
    if (newlyAppliedPromotions.length === 0 && availablePromotions.length) {
      //remove the lastShownPromotions from local storage if there are no newly applied promotions
      sessionStorage.removeItem("lastShownPromotions");
    }
    const currentPromotions = JSON.stringify(newlyAppliedPromotions);
    const lastShownPromotions = sessionStorage.getItem("lastShownPromotions");
    const isSamePromotions = lastShownPromotions === currentPromotions;
    if (newlyAppliedPromotions.length && !isSamePromotions) {
      setShow(true);
      currentAppliedPromotionRef.current =
        newlyAppliedPromotions[newlyAppliedPromotions.length - 1];
    }
  }, [
    JSON.stringify(newlyAppliedPromotions),
    JSON.stringify(availablePromotions),
  ]);

  const handleClose = () => {
    sessionStorage.setItem(
      "lastShownPromotions",
      JSON.stringify(newlyAppliedPromotions)
    );
    setShow(false);
    userAcknowledgedPromotionsHandler(newlyAppliedPromotions);
    toggleUserClosePromotionPopup(true);
  };

  return (
    <Modal
      show={show}
      centered
      dialogClassName="promotion-applied-modal centered"
    >
      <div className="popup-overlay" />
      <div className="popup-banner">
        <img src={promotionAppliedIcon} className="icon" />
        <h2 className="popup-heading">
          <FormattedMessage
            id="promotions.promotion_unlocked"
            defaultMessage="Promotion Unlocked!"
          />
        </h2>
        <div className="description-container">
          <p className="popup-desc">
            <span>{currentAppliedPromotionRef.current?.name}</span>
          </p>
        </div>
        <div>
          <button className="ok-button" onClick={handleClose}>
            <FormattedMessage id="button.ok" defaultMessage="OK" />
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AppliedPromotionsModalMobile;
